import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IFundingMod } from '../IFundingMod';
import { IChargeNumberManagement } from '../IChargeNumberManagement';
import { IContract } from '../presenters';

export const getFundingMod = createAction(
  '[FundingMod/API] Get Funding Mod',
  props<{ contract: IContract }>()
);

export const putFundingMod = createAction(
  '[FundingMod/API] Update Funding Mod',
  props<{ fundingMod: Array<IFundingMod> }>()
);

export const removeFundingMod = createAction(
  '[FundingMod/API] Remove Funding Mod',
  props<{ ids: Array<string> }>()
);

export const loadFundingMods = createAction(
  '[FundingMod/API] Load FundingMods',
  props<{ fundingMods: IFundingMod[] }>()
);

export const addFundingMod = createAction(
  '[FundingMod/API] Add FundingMod',
  props<{ fundingMod: IFundingMod }>()
);

export const upsertFundingMod = createAction(
  '[FundingMod/API] Upsert FundingMod',
  props<{ fundingMod: IFundingMod }>()
);

export const addFundingMods = createAction(
  '[FundingMod/API] Add FundingMods',
  props<{ fundingMods: IFundingMod[] }>()
);

export const upsertFundingMods = createAction(
  '[FundingMod/API] Upsert FundingMods',
  props<{ fundingMods: IFundingMod[] }>()
);

export const updateFundingMod = createAction(
  '[FundingMod/API] Update FundingMod',
  props<{ fundingMod: Update<IFundingMod> }>()
);

export const updateFundingMods = createAction(
  '[FundingMod/API] Update FundingMods',
  props<{ fundingMods: Update<IFundingMod>[] }>()
);

export const deleteFundingMod = createAction(
  '[FundingMod/API] Delete FundingMod',
  props<{ id: string }>()
);

export const deleteFundingMods = createAction(
  '[FundingMod/API] Delete FundingMods',
  props<{ ids: string[] }>()
);

export const clearFundingMods = createAction(
  '[FundingMod/API] Clear FundingMods'
);
